import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { createFetchByIds, createSearchWebInteractives, searchWebInteractives, fetchByIds } from 'reference-resolvers/api/WebInteractiveAPI';

// @ts-expect-error untyped module
import createBatchedReferenceResolver from '../lib/createBatchedReferenceResolver';
export const createWebInteractiveOptionsReferenceResolver = () => createBatchedReferenceResolver({
  cacheKey: CacheKeys.WEB_INTERACTIVES,
  createFetchByIds,
  createFetchSearchPage: createSearchWebInteractives,
  fetchByIds,
  fetchSearchPage: searchWebInteractives
});
export default createWebInteractiveOptionsReferenceResolver();